var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurantActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4697 18V19C22.4697 20.65 22.4697 22 19.4697 22H5.46973C2.46973 22 2.46973 20.65 2.46973 19V18C2.46973 17.45 2.91973 17 3.46973 17H21.4697C22.0197 17 22.4697 17.45 22.4697 18Z",
    fill: "url(#paint0_linear_1721_53265)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9095 5.17977C14.9595 4.97977 14.9895 4.78977 14.9995 4.57977C15.0295 3.41977 14.3195 2.39977 13.1995 2.09977C11.5195 1.63977 9.99953 2.89977 9.99953 4.49977C9.99953 4.73977 10.0295 4.95977 10.0895 5.17977C6.47953 5.94977 3.76953 9.15977 3.76953 12.9998V14.4998C3.76953 15.0498 4.21953 15.4998 4.76953 15.4998H20.2195C20.7695 15.4998 21.2195 15.0498 21.2195 14.4998V12.9998C21.2195 9.15977 18.5195 5.95977 14.9095 5.17977ZM15.4995 11.7498H9.49953C9.08953 11.7498 8.74953 11.4098 8.74953 10.9998C8.74953 10.5898 9.08953 10.2498 9.49953 10.2498H15.4995C15.9095 10.2498 16.2495 10.5898 16.2495 10.9998C16.2495 11.4098 15.9095 11.7498 15.4995 11.7498Z",
    fill: "url(#paint1_linear_1721_53265)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1721_53265",
    x1: 12.4697,
    y1: 17,
    x2: 12.4697,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1721_53265",
    x1: 12.4945,
    y1: 2.00391,
    x2: 12.4945,
    y2: 15.4998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A79D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantActive);
export default __webpack_public_path__ + "static/media/restaurant-active.26284006bdc8f0719cf83d821f418b61.svg";
export { ForwardRef as ReactComponent };